import { push } from 'redux-first-history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/SMSIcon.svg';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';
import RememberMe from '../shared/RememberMe';

/**
 * SmsPage Component
 */
export class SmsPage extends Component {
  /**
   * The allowed properties for the SmsPage component
   * @param {function} verifySms verify the sms token code that was sent to the user
   * @param {function} resendSms resend a new sms token code to the user
   * @param {bool} isLoading is something on the page loading?
   * @param {string} lastFourDigits the last four digits of the enrolled phone number
   * @param {array} availableModalities available modalities to switch to
   */
  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool,
    lastFourDigits: PropTypes.string,
    resendSms: PropTypes.func.isRequired,
    verifySms: PropTypes.func.isRequired,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };

  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    useCustomUX: false,
  };

  submitForm = data => {
    this.props.verifySms(data.tokenCode);
  };

  resendSms = () => {
    this.props.resendSms();
  };

  render() {
    const {
      availableModalities,
      isLoading,
      lastFourDigits,
      logout,
      serverState,
      useCustomUX,
      username,
      allowEditUsername,
    } = this.props;

    let headerDesc = <p>Code sent to number ending in <strong>{lastFourDigits}</strong></p>;
    let moreOptions = null;
    let moreOptionsMarkup = <MoreOptions currentModality='sms' />;
    let moreOptionsAltMarkup = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'sms') : [];
    const modalitiesArePresent = modalities.length > 0;
    const hasTempCodeMessage = serverState && serverState.temporaryCodeAllowed && !serverState.temporaryCodeAvailable;

    modalitiesArePresent && (moreOptions = moreOptionsMarkup);
    (hasTempCodeMessage && !modalitiesArePresent) && (moreOptions = moreOptionsAltMarkup);
    const logoutStyle = useCustomUX ? 'black' : 'white';

    return (
      <div className='content-body'>
        <SingleInput
          isLoading={isLoading}
          headerTitle='SMS code'
          headerImage={headerImage}
          headerDescription={headerDesc}
          placeholderText='Verification code'
          submitText='Confirm your identity'
          onSubmit={this.submitForm}
          inputType='text'
          retryText="Didn't get a code?"
          onRetryClick={this.resendSms}
          moreOptionsLink={moreOptions}
          onLogoutClick={logout}
          maxLength='6'
          autoFocus={true}
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          footer={<RememberMe />}
          useCustomUX={useCustomUX}
          username={username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        />
      </div>
    );
  }
};

const mapStateToProps = state => {
  const {
    availableModalities, isDeviceManagementWorkflow, isLoading, lastFourDigits, serverState, useCustomUX,
    username, isClinicalWorkflow, allowEditUsername,
  } = state.login;
  return {
    availableModalities,
    isDeviceManagementWorkflow,
    isLoading,
    lastFourDigits,
    serverState,
    useCustomUX,
    username,
    allowEditUsername,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifySms: tokenCode => {
      dispatch(actions.verifySms(tokenCode) );
    },
    resendSms: () => {
      dispatch(actions.resendSms() );
    },
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SmsPage);
